<template>
    <ld-button
        class="button-toggle-expand"
        @click="() => expandElement(
            expandedElementId,
            expandedElementWrap,
            onTogleExpansion,
        )"
        color="dark"
        icon-pack="feather"
        icon="icon-maximize-2"
        type="flat"
        :disabled="disabled"
    >
    </ld-button>
</template>

<script>
import Router from '@/routers';
import { expandElement, retractElement } from '../utils/expandElement'

export default {
    name: 'LdFullscreenToggleExpandButton',
    props: {
        onToggle: {
            type: Function,
            required: false,
            default: () => {}
        },
        expandedElementId: {
            required: true,
            type: String
        },
        expandedElementWrap: {
            required: false,
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        expandElement,
        retractElement,
        popStateEvent() {
            this.retractElement(
                this.expandedElementId,
                this.expandedElementWrap,
                this.onTogleExpansion
            );
        },
        onTogleExpansion(value) {
            this.setInQuery(value);
            this.onToggle(value);
        },
        removeHook() {
            const hookIndex = this.$router.beforeHooks.findIndex(hook => hook === this.beforeRouteEnter);
            this.$router.beforeHooks.splice(hookIndex, 1);
        },
        beforeRouteEnter(to, from, next) {

            if (to.name !== from.name) {
                this.popStateEvent();
            }

            this.removeHook();
            next();
        },
        setInitialState() {
            const query = new URLSearchParams(window.location.search);
            const tableExpanded = query.get("element_expanded");

            if (tableExpanded === 'true') {
                this.expandElement(
                    this.expandedElementId,
                    this.expandedElementWrap,
                    this.onTogleExpansion,
                );
            }
        },
        setInQuery(value) {
            let queries = new URLSearchParams(window.location.search);
            queries.set("element_expanded", value);
            queries = queries.toString();
            queries = queries ? `?${queries}` : '';

            const lastPath = window.location.pathname.split('/').pop();
            window.history.replaceState(null, null, `${lastPath}${queries}`);
        }
    },
    watch: {
        expandedElementWrap() {
            this.setInitialState();
        }
    },
    mounted() {
        if (this.expandedElementId && this.expandedElementWrap === undefined) {
            this.setInitialState();
        }

        Router.beforeEach(this.beforeRouteEnter);
    },

}
</script>
